import { pipe } from 'ramda';
import { useMemo } from 'react';

import { useCollections } from './useCollections';
import { CMSGameCategory } from '@/api/cms';
import { filterByGroups } from '@/helpers/cms';
import { UpdatedGameCategory } from '@/helpers/game';
import { formatCategories } from '@/helpers/gameFiltration';
import { useServer } from '@/modules/server/context/ServerEnvContext';
import { useCommonStore } from '@/store';

export const useCMSGameCategories = () => {
  const user = useCommonStore.use.user();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const { collections } = useCollections();
  const { gameCategories: data } = useServer();

  const categories = useMemo(() => {
    if (!data.length || !collections.length) return [];
    return pipe<
      [CMSGameCategory[]],
      UpdatedGameCategory[],
      UpdatedGameCategory[]
    >(
      formatCategories(isAuthenticated, collections),
      // TODO: optimize logic to avoid client-side filterByGroups
      filterByGroups<UpdatedGameCategory>({ user })
    )(data);
  }, [data, user, isAuthenticated, collections]);

  return { categories };
};
